/** Единые публичные реквизиты продавца (ЗоЗПП ст. 8–9). */
export const SELLER = {
  brand: 'LavSan',
  name: 'ИП МАНУКЯН Г.В.',
  fullName: 'индивидуальный предприниматель Манукян Гайк Варданович',
  inn: '231012807797',
  ogrnip: '323237500407250',
  address: 'г. Краснодар, ул. Красных Партизан/им. Котовского, 489/103',
  phoneDisplay: '+7 (918) 046‑67‑20',
  phoneTel: '+79180466720',
  email: 'haykm001@mail.ru',
  hours: '09:00–18:00',
  site: 'https://lav-san.ru',
  updatedAt: '21.08.2026',
};

export function SellerContacts({ showTitle = false } = {}) {
  const s = SELLER;
  return (
    <p>
      {showTitle ? <strong>Продавец: </strong> : null}
      {s.name}, ИНН {s.inn}, ОГРНИП {s.ogrnip}. Контакты: телефон:{' '}
      <a href={`tel:${s.phoneTel}`}>{s.phoneDisplay}</a>, e‑mail:{' '}
      <a href={`mailto:${s.email}`}>{s.email}</a>, адрес: {s.address}. Режим работы:{' '}
      {s.hours}.
    </p>
  );
}
